import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { useIntl } from "react-intl";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  icon?: React.ReactNode;
}

export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  loading = false,
  icon,
}: ConfirmDialogProps) {
  const intl = useIntl();

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="sm">
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {icon}
          <Typography variant="h6">
            {title || intl.formatMessage({ id: "deleteConfirmTitle" })}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {message || intl.formatMessage({ id: "deleteConfirmMessage" })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {cancelLabel || intl.formatMessage({ id: "deleteCancelLabel" })}
        </Button>
        <Button
          color="error"
          onClick={handleConfirm}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} /> : null}
        >
          {confirmLabel || intl.formatMessage({ id: "deleteConfirmLabel" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
